<template>
    <b-row class="payment-calculator mt-3">
        <b-col cols="12">
            <h2 class="mb-3">Calculadora de Cambio</h2>
        </b-col>
        <b-col md="6" sm="12">
            <label for="amountDue">Importe a PAGAR:</label>
            <input v-model.number="amountDue" type="number" id="amountDue" disabled />
        </b-col>
        <b-col md="6" sm="12">
            <label for="amountPaid">Importe Recibido:</label>
            <input v-model.number="amountPaid" type="number" id="amountPaid" :min="amountDue" @input="calculateChange" />
        </b-col>
        <b-col cols="12" class="mt-2" v-if="change >= 0">
            <h3><b>CAMBIO: {{ change | formatear_precio }}</b></h3>
        </b-col>
        <b-col v-else>
            <b>El dinero recibido no puede ser inferior al importe a pagar.</b>
        </b-col>
    </b-row>
  </template>
  
<script>
export default {
    props: ['amountDue'],
    data() {
        return {
            amountPaid: 0,
            change: null
        };
    },
    methods: {
        calculateChange() {
            if (this.amountPaid >= this.amountDue) {
                this.change = this.amountPaid - this.amountDue;
            } else {
                this.change = -1;
            }
        }
    }
};
</script>
  
<style scoped>
    .payment-calculator {
        margin: 0 auto;
        padding: 15px;
        border: 1px solid #ccc;
        border-radius: 4px;
    }

    .payment-calculator h2 {
        font-size: 25px;
    }

    .payment-calculator div {
        margin-bottom: 10px;
    }

    .payment-calculator label {
        display: block;
        margin-bottom: 5px;
    }

    .payment-calculator input {
        width: 100%;
        padding: 8px;
        box-sizing: border-box;
    }

    .payment-calculator button {
        width: 100%;
        padding: 22px;
        background-color: #42b983;
        color: white;
        border: none;
        cursor: pointer;
    }

    .payment-calculator button:hover {
        background-color: #38a373;
    }
</style>
  